import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2, Truck } from "lucide-react";
import { api, setToken } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useToast } from "../hooks/use-toast";

const DeliveryLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast({ title: "Eksik bilgi", description: "E-posta ve şifre zorunlu." });
      return;
    }
    try {
      setBusy(true);
      const res = await api.post("/auth/login", { email, password });
      if (res.data.role !== "delivery") {
        toast({ title: "Yetkisiz", description: "Bu panele giriş için yetkiniz yok." });
        return;
      }
      setToken(res.data.access_token);
      toast({ title: "Giriş başarılı", description: "Teslimat paneline yönlendiriliyorsunuz." });
      navigate("/teslimat/panel");
    } catch (err) {
      toast({ title: "Giriş başarısız", description: err?.response?.data?.detail || "Sunucuya ulaşılamadı." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white shadow-2xl mb-4">
            <Truck className="w-8 h-8 text-[#b91c1c]" />
          </div>
          <h1 className="text-3xl font-black text-white">Aktav Yarka</h1>
          <p className="text-white/70 text-sm mt-1">Teslimat & Rota Yönetimi</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-2xl p-8 space-y-5">
          <div>
            <label className="text-xs font-semibold text-slate-700 mb-1.5 block">E-posta</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="destek@aktavyarka.com" className="pl-10 h-11" autoComplete="username" />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-700 mb-1.5 block">Şifre</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="pl-10 h-11" autoComplete="current-password" />
            </div>
          </div>
          <Button type="submit" disabled={busy} className="w-full h-11 bg-[#0f172a] hover:bg-[#1e293b] text-white font-semibold">
            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            {busy ? "Giriş yapılıyor..." : "Panele Gir"}
          </Button>
          <a href="/" className="block text-center text-xs text-slate-500 hover:text-slate-800">← Siteye dön</a>
        </form>
      </div>
    </div>
  );
};

export default DeliveryLogin;
